<template>
    <div>
        <bar-manut
        single-entity="Forma de Pagamento"
        plural-entity="Forma de Pagamento"
        :crud="this.crud"
        :btn-delete="true"
        @closeform="closeForm"
        @delete="handleDelete"
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <!-- <div class="row">
                <form-field v-model="fpag.codfpag" :metadata="metadata.fpag.codfpag"  type="text" col="2" :disabled="true"></form-field>
            </div> -->
            <!-- <div class="row">
                <form-field v-model.number="fpag.codfil" :required="true" :metadata="metadata.fpag.codfil" type="select2"  name="codfil"  col="3" :disabled="isView"></form-field>
            </div> -->
            <div class="row">
                  <form-field v-model.trim="fpag.descricao" :v-errors="errors" v-validate="{required:true, max:40}" :required="true" :metadata="metadata.fpag.descricao" ref="descricao"  type="text" col="6"
                    name="descricao" :disabled="isView"></form-field>
            </div>
            <!-- <div class="row">
                <form-field type="color" v-model.trim="fpag.corfundo" :metadata="metadata.fpag.corfundo" col="2" :disabled="isView"></form-field>
            </div> -->
            <div class="row">
                <form-field v-model="fpag.formapag" placeholder="Selecione" :value="fpag.formapag" type="select"  :metadata="metadata.fpag.formapag" col="3" :disabled="isView"></form-field >
                <!-- <form-field v-if="habilitaBandeira" v-model="fpag.bandeirapag" :value="fpag.bandeirapag" type="select"  :metadata="metadata.fpag.bandeirapag" col="2" :disabled="isView" ></form-field> -->
            </div>
            <label-title title="Taxa" v-if="habilitaBandeira"></label-title>
            <div class="row" v-if="habilitaBandeira">
                <!-- <form-field type="number" :v-errors="errors" v-validate="{required:true, max:2}" v-model.number="fpag.nparcelas" :metadata="metadata.fpag.nparcelas" :label="'Parcelas'" col="1" :required="true" :disabled="isView"></form-field> -->
                <form-field type="value" v-model.number="fpag.taxa" :metadata="metadata.fpag.taxa" col="2" :v-errors="errors" :precision="2" v-validate="metadata.fpag.taxa.validator" :disabled="isView"></form-field>
                <form-field type="value" v-model.number="fpag.taxafixa" :metadata="metadata.fpag.taxafixa" col="2" :disabled="isView"></form-field>
                <form-field type="number" v-model.number="fpag.diascredito" :metadata="metadata.fpag.diascredito" col="2"  :v-errors="errors" :precision="2" v-validate="metadata.fpag.validator" :disabled="isView"></form-field>
            </div>
            <label-title title="Módulo Financeiro"></label-title>
            <validation v-if="!isCreditoLoja" :messages="['Selecione se esta forma de pagamento deve gerar um contas a receber ou lançamento no extrato']"></validation>
            <div class="row" v-if="!isCreditoLoja">
                <form-field v-model="fpag.lancamentofin" placeholder="Selecione" :value="fpag.lancamentofin" type="select"  :metadata="metadata.fpag.lancamentofin" col="3" :disabled="isView"></form-field>
            </div>
            <div class="row" v-if="!isCreditoLoja">
                <form-field v-model.number="fpag.codcta" type="select2" :metadata="metadata.fpag.codcta" name="codcta" col="3" :disabled="isView" ></form-field> <!--metadata.fpag.codcta NÃO ESTÁ CONFIGURADO PARA SELECT2-->
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import InputTypeahead from '../components/input-typeahead'
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import {SysVars} from '../main'
export default {
    props:{
        index: '',
        crud:''
    },
        components: {
        InputTypeahead
    },
    data(){
        return{
            crudText: '',
            fpag:{...this.$store.getters.getEntities.fpag},
            metadata: this.$store.getters.getEntities.metadata,
            codfpag:0,
            errMessages: [], // Armazena as mensagens de validações do servidor para mostrar na tela
            filial: {},
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        },
        isView(){
            return (this.crud == SysVars.crudView)
        },
        isCreditoLoja: function () {
            return this.fpag.formapag == '05' //credito loja
        },
        habilitaBandeira: function () {
            return (this.fpag.formapag == '03' || this.fpag.formapag ==  '04' || this.fpag.formapag ==  '10' || this.fpag.formapag ==  '11' || this.fpag.formapag ==  '12' || this.fpag.formapag == '13')
        },
     },

    methods:{
        closeForm(){
            this.$emit('closeform', this.fpag.codfpag)
        },
        handleSave(){
            // delete this.this.fpag.badeirapag && delete this.fpag.tpdiacredito
            //Validação do formulário
            this.$validator.validateAll().then(isValid =>{
                if(!isValid){
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else{
                    this.apiPost()
                }
            })
        },
        handleDelete(){
            this.apiDelete()
        },

        async loadFilial() {
          await apiORDS(this.$store.getters.urlOrds + 'cg/filial/varejo', null, true).then((result) => {
            if (result.items.length > 0) {
              this.filial = result.items[0];
            }
          })
        },

        async loadData(){
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadFpag', {id: this.index})
            if (this.$store.getters.getFpag){
                this.fpag = {...this.$store.getters.getFpag}
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiPost(){
            //efetuaGravacao

            var modulo = 'cg/fpag/'
            var sendData = {}

            sendData = { fpag: this.fpag }

            let metodo = 'post'
            let update = false

            if(this.crud != SysVars.crudI){
                update = true
                metodo = 'put'
                modulo = modulo + this.fpag.codfpag
            }
            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if(data.errmessages){
                this.errmessages = data.errmessages
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if(update){
                    this.$erpToastUpdated()
                } else{
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        async apiDelete(){
            //efetua exclusão
            var modulo = 'cg/fpag/' + this.fpag.codfpag
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        }
    },

    async created(){
        this.crudText = this.$crudText(this.crud)

        await this.loadFilial();

        if(this.crud == SysVars.crudI){
          this.fpag.codfil = this.filial.codfil
        } else{
            this.loadData()
        }
           this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })

    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/fpag-form.vue